import { render, staticRenderFns } from "./GoodsItemDouble.vue?vue&type=template&id=58dfe84f&scoped=true"
import script from "./GoodsItemDouble.vue?vue&type=script&lang=js"
export * from "./GoodsItemDouble.vue?vue&type=script&lang=js"
import style0 from "./GoodsItemDouble.vue?vue&type=style&index=0&id=58dfe84f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58dfe84f",
  null
  
)

export default component.exports